module.exports = __webpack_public_path__ + "static/3-5cb721871d5f128d4a8a1a2af18baff0.gif";